import { render, staticRenderFns } from "./SphereDetail.vue?vue&type=template&id=982366a6&scoped=true"
import script from "./SphereDetail.vue?vue&type=script&lang=js"
export * from "./SphereDetail.vue?vue&type=script&lang=js"
import style0 from "./SphereDetail.vue?vue&type=style&index=0&id=982366a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982366a6",
  null
  
)

export default component.exports